/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigTagsRequest {
    getFixupPrototypeFunction() { return LockConfigTagsRequest.fixupPrototype; }

    static newInstance(model: Partial<LockConfigTagsRequest>): LockConfigTagsRequest {
        let obj = Object.assign(new LockConfigTagsRequest(), model);
        LockConfigTagsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigTagsRequest>): LockConfigTagsRequest {
        if (!model) return null;
        return LockConfigTagsRequest.newInstance(<LockConfigTagsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigTagsRequest) {
        if (!obj) return;

        models.LockConfigTagsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigTagsRequest): boolean {
        Object.setPrototypeOf(obj, LockConfigTagsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
